<div class="recomendation__package-container">
    <span>{{'migrateHalo.recomendation' | translate}}</span>
    <div class="packages">
            <app-package-card (click)="onCickPackage(data())" (keydown)="onCickPackage(data())" [data]="handlePackageCardData(data())"/>
    </div>
</div>